import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PanelModificacionFichajes from './PanelModificacionFichajes';
import { API_BASE } from '../api';

function UsuarioInfo({ token }) {
  const [usuario, setUsuario] = useState(null);
  const [hoverIdx, setHoverIdx] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModify, setShowModify] = useState(false);

  useEffect(() => {
    async function fetchUser() {
      try {
        const apiUrl = `${API_BASE}/api/auth/me`;
        const res = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUsuario(res.data);
      } catch (err) {
        setUsuario(null);
        console.error('Error al obtener usuario:', err);
      }
    }
    fetchUser();
  }, [token]);

  if (!usuario) return null;

  // Ordenar dispositivos por fecha de registro ascendente
  const dispositivosOrdenados = (usuario.dispositivos || []).slice().sort((a, b) => {
    if (!a.fechaRegistro) return 1;
    if (!b.fechaRegistro) return -1;
    return new Date(a.fechaRegistro) - new Date(b.fechaRegistro);
  });

  // Iconos por tipo de dispositivo
  const getIcon = (tipo, so) => {
    if (tipo === 'web' && so === 'Windows') return <span title="Windows" style={{fontSize:24}}>🖥️</span>;
    if (tipo === 'web' && so === 'macOS') return <span title="Mac" style={{fontSize:24}}>🍏</span>;
    if (tipo === 'web' && so === 'iOS') return <span title="iPhone" style={{fontSize:24}}>📱</span>;
    if (tipo === 'web' && so === 'Android') return <span title="Android" style={{fontSize:24}}>🤖</span>;
    if (tipo === 'web') return <span title="Web" style={{fontSize:24}}>🌐</span>;
    return <span style={{fontSize:24}}>🔧</span>;
  };
  return (
    <div className="component-box" style={{
      maxWidth: 800,
      margin: '0 auto 24px',
      background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(59, 130, 246, 0.08) 100%)',
      border: '2px solid rgba(16, 185, 129, 0.2)',
      borderRadius: '20px',
      position: 'relative',
      overflow: 'visible',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      padding: '24px'
    }}>
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(20deg); }
          75% { transform: rotate(-20deg); }
        }
        
        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(16, 185, 129, 0.3); }
          50% { box-shadow: 0 0 30px rgba(16, 185, 129, 0.6); }
        }
        
        .user-card {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-bottom: 20px;
          animation: slideUp 0.5s ease-out;
        }
        
        .user-card-item {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          padding: 20px;
          border-radius: 16px;
          border: 2px solid #e2e8f0;
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          position: relative;
          overflow: hidden;
        }
        
        .user-card-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(16, 185, 129, 0.1), transparent);
          transition: left 0.5s;
        }
        
        .user-card-item:hover::before {
          left: 100%;
        }
        
        .user-card-item:hover {
          border-color: #10b981;
          box-shadow: 0 8px 24px rgba(16, 185, 129, 0.2);
          transform: translateY(-4px) scale(1.02);
        }
        
        .user-card-label {
          font-size: 0.85rem;
          color: #64748b;
          margin-bottom: 8px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
        
        .user-card-value {
          font-size: 1.15rem;
          color: #1e293b;
          font-weight: 700;
        }
        
        .device-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
          gap: 12px;
          margin-top: 16px;
        }
        
        .device-icon {
          position: relative;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          padding: 20px;
          text-align: center;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          font-size: 36px;
          animation: slideUp 0.5s ease-out backwards;
        }
        
        .device-icon:hover {
          border-color: #3b82f6;
          transform: translateY(-8px) scale(1.1) rotate(5deg);
          box-shadow: 0 12px 28px rgba(59, 130, 246, 0.3);
          animation: glow 1.5s infinite;
        }
        
        @keyframes tooltipFade {
          from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }
        
        .modify-btn {
          border: 3px solid transparent;
          background: 
            linear-gradient(white, white) padding-box,
            linear-gradient(135deg, #FF3B8F 0%, #A855F7 20%, #3B82F6 40%, #06B6D4 60%, #10B981 80%, #FB923C 100%) border-box;
          background-size: auto, 300% 300%;
          color: #1e293b;
          padding: 16px 32px;
          border-radius: 16px;
          font-weight: 800;
          font-size: 1.05rem;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          box-shadow: 
            0 6px 20px rgba(0, 0, 0, 0.08),
            0 3px 10px rgba(0, 0, 0, 0.05);
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 24px auto 0;
          position: relative;
          overflow: visible;
          animation: modifyRainbow 8s linear infinite;
        }
        
        @keyframes modifyRainbow {
          0% { background-position: 0% 50%, 0% 50%; }
          50% { background-position: 0% 50%, 100% 50%; }
          100% { background-position: 0% 50%, 0% 50%; }
        }
        
        @keyframes orangeOrb {
          0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
          50% { transform: translate(20px, -10px) scale(1.2); opacity: 0.8; }
        }
        
        /* Orbes sutiles detrás del botón */
        .modify-btn::before {
          content: '';
          position: absolute;
          width: 80px;
          height: 80px;
          background: radial-gradient(circle, rgba(255, 59, 143, 0.18) 0%, rgba(168, 85, 247, 0.12) 50%, transparent 70%);
          border-radius: 50%;
          top: 50%;
          left: -15px;
          transform: translateY(-50%);
          animation: orangeOrb 7s ease-in-out infinite;
          filter: blur(25px);
          pointer-events: none;
          z-index: -1;
        }
        
        .modify-btn::after {
          content: '';
          position: absolute;
          width: 65px;
          height: 65px;
          background: radial-gradient(circle, rgba(6, 182, 212, 0.18) 0%, rgba(16, 185, 129, 0.12) 50%, transparent 70%);
          border-radius: 50%;
          top: 50%;
          right: -15px;
          transform: translateY(-50%);
          animation: orangeOrb 9s ease-in-out infinite reverse;
          filter: blur(28px);
          pointer-events: none;
          z-index: -1;
        }
        
        .modify-btn:hover {
          transform: translateY(-4px) scale(1.05);
          box-shadow: 
            0 10px 35px rgba(0, 0, 0, 0.12),
            0 5px 18px rgba(0, 0, 0, 0.08),
            0 0 50px rgba(168, 85, 247, 0.18);
          animation: modifyRainbow 4s linear infinite;
        }
        
        .modify-btn:active {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 
            0 5px 18px rgba(0, 0, 0, 0.1),
            0 2px 8px rgba(0, 0, 0, 0.06);
        }
        
        .modify-btn-text {
          position: relative;
          z-index: 1;
        }
        
        .wave-hand {
          display: inline-block;
          animation: wave 2s ease-in-out infinite;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      
      {/* Encabezado de bienvenida con toggle - siempre visible */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: isExpanded ? '20px' : '0',
        cursor: 'pointer',
        padding: '12px 16px',
        background: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '12px',
        transition: 'all 0.3s',
        border: '1px solid rgba(59, 130, 246, 0.2)'
      }}
      onClick={() => setIsExpanded(!isExpanded)}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.8)';
        e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
        e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.2)';
      }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span className="wave-hand" style={{ fontSize: '2.5rem' }}>👋</span>
          <h2 style={{ margin: 0, fontSize: '1.8rem', fontWeight: 700, color: '#1e293b' }}>
            Bienvenido, {usuario.nombre} {usuario.apellidos}
          </h2>
        </div>
        <span style={{
          fontSize: '1.2rem',
          color: '#64748b',
          transition: 'transform 0.3s',
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          display: 'inline-block'
        }}>
          ▼
        </span>
      </div>
      
      {/* Contenido colapsable: email, rol y dispositivos */}
      <div style={{
        maxHeight: isExpanded ? '2000px' : '0',
        overflow: isExpanded ? 'visible' : 'hidden',
        transition: 'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s',
        opacity: isExpanded ? 1 : 0
      }}>
        {/* Información básica */}
        <div className="user-card" style={{ marginBottom: '24px', marginTop: '16px' }}>
          <div className="user-card-item">
            <div className="user-card-label">📧 Email</div>
            <div className="user-card-value">{usuario.email}</div>
          </div>
          <div className="user-card-item">
            <div className="user-card-label">🏷️ Rol</div>
            <div className="user-card-value" style={{ 
              color: usuario.role === 'admin' ? '#ef4444' : '#10b981',
              textTransform: 'capitalize'
            }}>
              {usuario.role}
            </div>
          </div>
        </div>
        
        {/* Dispositivos */}
        <div style={{ marginTop: '24px' }}>
          <h3 style={{
            fontSize: '1.1rem',
            color: '#1e293b',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span>💻</span>
            Dispositivos registrados ({dispositivosOrdenados.length})
          </h3>
          
          <div className="device-grid">
            {dispositivosOrdenados.map((d, idx) => (
              <div 
                key={idx}
                className="device-icon"
                style={{
                  animationDelay: `${idx * 0.05}s`
                }}
                onMouseEnter={() => setHoverIdx(idx)}
                onMouseLeave={() => setHoverIdx(null)}
              >
                {getIcon(d.tipo, d.so)}
                {hoverIdx === idx && (
                  <div className="device-tooltip" style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'white',
                    border: '2px solid #3b82f6',
                    borderRadius: '16px',
                    padding: '18px',
                    minWidth: '280px',
                    maxWidth: '90vw',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                    zIndex: 100,
                    fontSize: '0.9rem',
                    lineHeight: 1.9,
                    animation: 'tooltipFade 0.2s ease-out'
                  }}>
                    <div style={{ marginBottom: '8px', fontWeight: 700, color: '#2563eb', fontSize: '1rem' }}>
                      Información del dispositivo
                    </div>
                    <div style={{ color: '#64748b' }}>
                      <strong>Tipo:</strong> {d.tipo || '-'}<br/>
                      <strong>SO:</strong> {d.so || '-'}<br/>
                      <strong>Navegador:</strong> {d.navegador || '-'}<br/>
                      <strong>IP:</strong> {d.ip || '-'}<br/>
                      <strong>Fecha:</strong> {d.fechaRegistro ? new Date(d.fechaRegistro).toLocaleDateString() : '-'}<br/>
                      {d.ubicacion && (
                        <>
                          <strong>📍 Ubicación:</strong><br/>
                          <span style={{ fontSize: '0.85rem', marginLeft: '4px' }}>
                            Lat: {d.ubicacion.latitud?.toFixed(6) || '-'}<br/>
                            <span style={{ marginLeft: '4px' }}>
                              Lon: {d.ubicacion.longitud?.toFixed(6) || '-'}
                            </span>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Botón para modificar fichajes (solo si allowModify) */}
      {usuario.allowModify && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            className="modify-btn"
            onClick={() => setShowModify(v => !v)}
          >
            <span style={{ fontSize: '1.3em' }}>✏️</span>
            <span className="modify-btn-text">
              {showModify ? 'Cerrar modificación de fichajes' : 'Modificar fichajes'}
            </span>
          </button>
        </div>
      )}
      
      {/* Panel de modificación de fichajes */}
      {usuario.allowModify && showModify && (
        <div style={{ marginTop: '24px' }}>
          <PanelModificacionFichajes token={token} usuario={usuario} />
        </div>
      )}
    </div>
  );
}

export default UsuarioInfo;
